import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import dataV from "@jiaminghi/data-view";
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";
// 引入全局css
import "./assets/scss/style.scss";
// 引入图表（所有图标见 icon 目录下的 demo_index.html）
import "./assets/icon/iconfont.css";
//引用项目icon
import "./assets/icon/iconfontMaterialApp.css";
// 引入 全局注册组件
import PublicComponent from "@/components/componentInstall";
import { useMainAppStore } from "@/store/mainApp";

const pinia = createPinia();

// 定义从主应用接收的 Props 类型
interface QiankunProps {
  container?: HTMLElement;
  token?:String,
  onGlobalStateChange?: (callback: (state: any, prevState: any) => void) => void;
  setGlobalState?: (state: Record<string, any>) => void;
}

let instance: any = null;

function render(props: QiankunProps = {}) {
  const { container, token} = props;
  instance = createApp(App);
  // instance.use(ElementPlus, {
  //   locale: zhCn,
  // });
  instance.provide('qiankunProps', props);
  instance.use(PublicComponent);
  instance.use(dataV);
  instance.use(pinia);
  instance.use(router);

  instance.mount(
    container
      ? container.querySelector("#qiankunSubMaterialDashboardApp")
      : "#qiankunSubMaterialDashboardApp"
  );
  if (token) {
    useMainAppStore().setToken(token);
  }
}

// 独立运行时直接渲染
if (!(window as any).__POWERED_BY_QIANKUN__) {
  document.getElementById("qiankunSubMaterialDashboardApp").style.width =
    "100vw";
  document.getElementById("qiankunSubMaterialDashboardApp").style.height =
    "100vh";
  render({});
}

if ((window as any).__POWERED_BY_QIANKUN__) {
  __webpack_public_path__ = (window as any).__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}

// 导出 Qiankun 生命周期
export async function bootstrap() {
  console.log("Vue子应用启动");
}

export async function mount(props: QiankunProps) {
  render(props);
}

export async function unmount() {
  instance.unmount();
  instance = null;
}
